import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import {
  goodsItemsGetAction,
  purchaseInvoiceViewAction,
  purchaseItemsGetAction,
  dropListItemsGetAction,
} from "../../../redux/actions/purchase-action";
import CreateEditViewPurInv from "../../../components/purchase-section/purchase-invoice/create-edit-view-pur-inv";

const AddPurchaseInvoice = () => {
  const location = useLocation();
  const values = location.state?.values || [];
  const { itemData, ...rest } = values;
  const { itemId, type } = useParams();
  const itemIdArray = JSON.parse(decodeURIComponent(itemId));
  const [searchParams] = useSearchParams();
  const transfer=searchParams.has("transfer");
  //

  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //

  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {}, []);

  useEffect(() => {
    if (isClone) {
      setLoading(true);

      dispatch(purchaseInvoiceViewAction(cloneID, onCloneSuccPur, onErrPur));
    }

    if (type === "purchase") {
      setLoading(true);
      dispatch(purchaseItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "goods") {
      setLoading(true);
      dispatch(goodsItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "droplist") {
      setLoading(true);
      dispatch(dropListItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onSuccPur = (data) => {
    console.log(data, "fgdgdfgdfgdfgdfgdf");
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};
  const prefix = searchParams.get("type") || "gort";
  const isNew = searchParams.has("new");

  console.log(itemData, "ssdffsdfsfsfsdfsdfsf");
  return (
    <InnerLayout backBtn={true} title={`${isClone ? "Clone" : "Add"}  Purchase Invoice`}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPurInv
          isClone={isClone}
          clickedplus={isNew}
          transfer={transfer===true}
          payto={
            isClone
              ? orderData?.poit_pay_to_address
              : vendorDetails?.[`${prefix}_pay_to_address`]
          }
          shipto={
            isClone
              ? orderData?.poit_ship_to_address
              : vendorDetails?.[`${prefix}_ship_to_address`]
          }
          pageType="purchase invoice"
          page="add"
          pageName="purchase invoice"
          setLoading={setLoading}
          setOrderDetail={setOrderDetail}
          // <CreateEditViewPurchaseInvoice
          disabled={type === "goods" || type === "droplist"}
          type={type}
          orderDetail={
            isClone
              ? orderDetail?.itemData
              : values?.itemData?.length > 0
              ? values?.itemData
              : orderDetail?.itemData
          }
          vendorDetails={
            isClone
              ? [orderData]
              : values?.itemData?.length > 0
              ? [rest]
              : [
                  {
                    ...vendorDetails,
                    poit_sub_total: orderData?.sub_total,
                    poit_total_gst: orderData?.total_tax,
                    poit_total_discount: orderData?.total_discount,
                    poit_total_amount: orderData?.total_amount,
                    poit_round_off_value: orderData?.round_off_value,
                    poit_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                    poit_tcs_or_tds_percentage_id:
                      orderData?.tcs_or_tds_percentage_id,
                    poit_tcs_or_tds_percentage:
                      orderData?.tcs_or_tds_percentage,
                    poit_tds_tcs_type: orderData?.tcs_or_tds_type,
                    poit_is_invoice_dis_percentage:
                      orderData?.is_invoice_dis_percentage ?? true,
                    poit_invoice_discount: orderData?.invoice_discount ?? 0,
                    poit_invoice_discount_percentage:
                      orderData?.invoice_discount_percentage ?? 0,
                  },
                ]
          }
        />
      )}
    </InnerLayout>
  );
};

export default AddPurchaseInvoice;
